import React, { Component, useState, useEffect, useRef } from 'react'
import useStateRef from 'react-usestateref';
import Helper from '../Helper';
import { APPLICATION_JSON, ZIP_CODE_API_KEY } from '../../middleware/types';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import Loader from '../Loader/Loader';
import { Link } from 'react-router-dom';
import OrderSummary from './OrderSummary';
import ProductRestrictionModal from './ProductRestrictionModal';

function CheckoutShipping({ containerObject, templateName, contentId, dataZone }) {
    const [pwd, setPwd] = useState('');
    const [isRevealPwd, setIsRevealPwd] = useState(false);
    const [isChecked, setIsChecked] = useState(false);
    const [hasError, setHasError, hasErrorRef] = useStateRef(false);
    const [isLoading, setIsLoading] = useState(false);
    const [errorMessage, setErrorMessage, setErrorMessageRef] = useStateRef();
    const [registerErrorMessage, setRegisterErrorMessage, setRegisterErrorMessageRef] = useStateRef();
    const [registerFormError, setRegisterFormError, registerFormErrorRef] = useStateRef(false);
    const [shippingGroupDetail, setShippingGroupDetail, shippingGroupDetailRef] = useStateRef();
    const [checkRegisterForm, setCheckRegisterForm, checkRegisterFormRef] = useStateRef(false);
    const [orderSummaryDetails, setOrderSummaryDetails, orderSummaryDetailsRef] = useStateRef(null);
    const [isOrderSummaryLoading, setOrderSummaryLoading, isOrderSummaryLoadingRef] = useStateRef(false);
    const [restrictModalGeo, setRestrictModalGeo, restrictModalGeoRef] = useStateRef();
    const [profileDetails, setProfileDetails, profileDetailsRef] = useStateRef();
    const profile = useSelector(state => state.getProfileDetails.profileDetails)
    const [redirectFlag, setRedirectFlag, redirectFlagRef] = useStateRef();
    const [myOrderBoxFix, setMyOrderBoxFix] = useState(false);
    const [emailUpdate, setEmailUpdate, emailUpdateRef] = useStateRef('');
    const [disabled, setDisabled, disabledRef] = useStateRef(false);
    const dispatch = useDispatch();
    const [postalCodeErrors, setPostalCodeErrors, postalCodeErrorsRef] = useStateRef([]);
    const [b2cApplyResponse, setb2cApplyResponse, b2cApplyResponseRef] = useStateRef();
    const [city, setCity, cityRef] = useStateRef('');
    const [state, setState, stateRef] = useStateRef('');
    const [zipCode, setZipCode, zipCodeRef] = useStateRef('')
    const cache = useRef({});
    const [responseCode, setResponseCode] = useState(0);

    const [search, setSearch, searchRef] = useStateRef("");
    const [localStorageintital, setLocalStorage, localStorageRef] = useStateRef({});
    var fieldNames = ["firstName", "lastName", "emailAddress", "phoneNumber", "companyName", "address1", "address2", "postalCode", "city", "state", "location"]
    let history = useHistory();
    const loaderStatus = useSelector(state => state.getLoaderStatus.loaderStatus)
    useEffect(() => {
        if (profileDetailsRef.current && profileDetailsRef.current.transient == true) {
            document.getElementById("registerForm").reset()
        }
    }, [profileDetailsRef.current])

    async function handleGetProfile() {
        setProfileDetails(profile);
        console.log('profile///', profileDetailsRef.current);
        if (profileDetailsRef.current && profileDetailsRef.current.transient || profileDetailsRef.current && profileDetailsRef.current.userType && profileDetailsRef.current.userType == '1' && shippingGroupDetailRef.current?.isUserFirstOrder == true) {
            if (document.getElementById("international-link")) {
                document.getElementById("international-link").classList.remove("d-none");
                document.getElementById("international-link").classList.add("d-block");
            }
        }
    }

    function handleCallBackOrderSummary() {
        getOrderSummaryDetails();
    }

    useEffect(() => {
        handleGetProfile()
    }, [profile])



    async function handleRestrictModal() {
        var actionUrl = 'api/rest/cb/cart/modal-quarantine'
        var Url = `${window.location.protocol}//${window.location.hostname}/${actionUrl}`
        var res = await Helper.fetchCallFunction(Url, "GET", false, APPLICATION_JSON, '');
        if (res.result == "success") {
            var response = (JSON.parse(res?.response))?.response
            setRestrictModalGeo(response)
            if (response?.restrictionProductsList && Object.keys(response?.restrictionProductsList).length > 0) {
                var modalElement = document.getElementById(`productRestrictionModalGuest`);
                var bootstrapModal = new bootstrap.Modal(modalElement);
                bootstrapModal.show();

            }
            else {
                if (document.getElementById('productRestrictionModalClose')) {
                    document.getElementById('productRestrictionModalClose').click();
                }

            }
        } else {

        }
    }

    const shipGroupDetails = (flag) => {
        const shippingParam = window.location.search
        setIsLoading(true);
        fetch(`${window.location.protocol}//${window.location.hostname}/api/rest/cb/checkout/shipping-group-details/${shippingParam === '?create=true' ? 'true' : shippingParam === '?qr=true' ? 'quarantine-message' : 'false'}`, {
            method: 'GET'
        }).then(res => res.json())
            .then(res => {
                if (res.result === "success") {
                    //        setIsLoading(false)

                    setShippingGroupDetail(JSON.parse(res.response).response)
                    setEmailUpdate(shippingGroupDetailRef.current?.email ? shippingGroupDetailRef.current.email : '')

                    setZipCode(shippingGroupDetailRef.current && shippingGroupDetailRef.current.postalCode);
                    if (shippingGroupDetailRef.current && shippingGroupDetailRef.current.city) {

                        setCity(shippingGroupDetailRef.current && shippingGroupDetailRef.current.city);
                    } else {
                        setCity()
                        if (shippingGroupDetailRef.current && shippingGroupDetailRef.current.postalCode) {
                            getCityAndStateByZipCode(zipCodeRef.current)
                        }

                    }

                    setState(shippingGroupDetailRef.current && shippingGroupDetailRef.current.state);
                    if (shippingParam !== '?create=true') {
                        if (shippingGroupDetailRef.current && shippingGroupDetailRef.current.isBillingSameAsShipping === true) {
                            if (document.getElementById('billingSameAsShipping')) {
                                document.getElementById('billingSameAsShipping').checked = true;
                            }
                        }
                        if (shippingGroupDetailRef.current && shippingGroupDetailRef.current.state && profileDetailsRef.current && profileDetailsRef.current.userType && (profileDetailsRef.current.userType == "1")) {
                            if (document.getElementById(shippingGroupDetailRef.current.state)) {
                                document.getElementById(shippingGroupDetailRef.current.state).setAttribute("selected", "selected")
                            }
                        }
                        if (profileDetailsRef.current && profileDetailsRef.current.transient || profileDetailsRef.current && profileDetailsRef.current.userType && profileDetailsRef.current.userType == '1' && shippingGroupDetailRef.current.isUserFirstOrder == true) {
                            document.getElementById("international-link").classList.remove("d-none");
                            document.getElementById("international-link").classList.add("d-block");
                        }
                    }
                    handleRestrictModal()
                    getOrderSummaryDetails();
                } else {
                    setIsLoading(false)
                   const response = res.response
                    const sendRedirect = response?.sendRedirect;
                    console.log('sendRedirect..',sendRedirect);
                    if(sendRedirect){
                        const redirectURL = res.response?.redirectURL;
                       if(redirectURL ){
                           history.push(redirectURL);
                       }
                    }
                    const error = res._ERROR_MESSAGE_;
                }
            })
    }

    useEffect(() => {
        if (loaderStatus == true) {
            console.log("log in shipping page loader true");
        } else {
            console.log("log in shipping page loader false");
            setSearch(window.location.pathname)
            if (containerObject && containerObject["@type"] == "CheckoutShipping" && searchRef.current == "/checkout/shipping") {
                setLocalStorageData(fieldNames)
                shipGroupDetails()
                //    populateDataLayer();
            }
        }
    }, [])
    const populateDataLayer = () => {
        window.dataLayer = window.dataLayer || []
        // const eventData = {"event":"checkoutAddress"}
        //     window.dataLayer.push(eventData);
    }
    function handleRemoveLocalStorage(fields) {
        fields.map((oneField) => {
            localStorage.removeItem(oneField)
        })
    }
    async function handleB2iShippingAddress(event) {
        setHasError(false)
        handleRemoveErrorMessage(setErrorMessageRef && setErrorMessageRef.current);

        var data = new FormData(event.target)
        if (shippingGroupDetailRef.current && shippingGroupDetailRef.current.companyName) {
            data.append("addressSelected", "true")
        } else {
            data.append("addressSelected", "false")
        }
        const value = Object.fromEntries(data.entries());
        if (value?.phoneNumber) {
            value['phoneNumber'] = value.phoneNumber.replaceAll('-', '');

        }

        if (!hasErrorRef.current) {
            var actionUrl = "api/rest/cb/checkout/b2i-apply-shipping-address";
            var Url = `${window.location.protocol}//${window.location.hostname}/${actionUrl}`
            var res = await Helper.fetchCallFunction(Url, "POST", false, APPLICATION_JSON, JSON.stringify(value))
            var response = JSON.parse(res.response)

            if (res.result == "success" && response.status == "success") {
                setIsLoading(false)
                handleRemoveLocalStorage(fieldNames)
                history.push("/checkout/delivery", "/checkout/shipping");
            }
            else {
                const errorList = ((JSON.parse(res.response)).errorMessage);
                errorList && errorList.map((item, index) => {
                    if (item.message && item.message === 'quarantine') {
                        handleRestrictModal()
                    } else {
                        handleErrorMessage(item.key, item.message)
                    }
                })
                setErrorMessage(errorList);
            }
        }
    }

    const handleRegistrationForm = async () => {

        if (profileDetailsRef.current && profileDetailsRef.current.transient) {
            var registerFormData = new FormData(document.getElementById("registerForm"))

            registerFormData.append("optIn", isChecked.toString())
            const registerFormValue = Object.fromEntries(registerFormData.entries())

            if (!checkRegisterFormRef.current) {
                Object.entries(registerFormValue).map(([key, value]) => {
                    if (key != "registrationStep" && key != "optIn" && key != "chooseAccountTypeErrorURL" && key != "custType") {
                        if (value.length != 0) {
                            setCheckRegisterForm(true)
                        }
                    }
                })
            }
            if (registerFormValue && registerFormValue["custType"]?.length != 0) {
                if (registerFormValue["firstName"]?.length == 0 && registerFormValue["lastName"]?.length == 0 && registerFormValue["email"]?.length == 0 && registerFormValue["password"]?.length == 0) {
                    setCheckRegisterForm(false)
                }
            }
            if (checkRegisterFormRef.current) {
                if (document.getElementById('exampleRadios1').checked == true) {
                    setRedirectFlag(true)
                    registerFormValue["previousUrl"] = "/checkout/school"
                } else {
                    setRedirectFlag(false)
                    registerFormValue["previousUrl"] = "/checkout/delivery"
                }
                var actionUrl = "api/rest/cb/profile/choose-account-type";
                var url = `${window.location.protocol}//${window.location.hostname}/${actionUrl}`
                var res = await Helper.fetchCallFunction(url, "POST", false, APPLICATION_JSON, JSON.stringify(registerFormValue))

                var response = JSON.parse(res.response)
                if (res.result == "success" && response.status == "success") {
                    console.log("success----", res.response)
                }
                else {
                    const errorList = response.errorMessage;
                    handleRegistrationMessage(errorList)
                    setRegisterErrorMessage(errorList);
                    setRegisterFormError(true);
                }

            }
        }
    }
    function handleLocalStorageData(event) {
        var data = new FormData(event.target)
        const formValue = Object.fromEntries(data.entries());
        Object.entries(formValue).map(([key, value], keyIndex) => {
            localStorage.setItem(key, value);
            setLocalStorage({ ...localStorageRef.current, [key]: value });
            if (key == "state") {
                setState(String(value))
            }
        })

    }
    function setLocalStorageData(fields) {
        fields.map((oneData) => {
            let oneVal = localStorage.getItem(oneData);
            setLocalStorage({ ...localStorageRef.current, [oneData]: oneVal })

            // here we need to set the city and state from the localStorage
            if (oneData == "city") {
                setCity(oneVal)
            }
            if (oneData == "state") {
                setState(String(oneVal))
            }
        })
    }
    async function handleB2cShippingAddress(event) {
        setHasError(false)
        setRegisterFormError(false)
        setCheckRegisterForm(false)
        handleRemoveErrorMessage(setErrorMessageRef && setErrorMessageRef.current);
        handleRemoveRegistrationMessage(setRegisterErrorMessageRef && setRegisterErrorMessageRef.current);
        var data = new FormData(event.target)
        data.append("selectedKey", "address-new")
        data.append("defaultShipping", "true")

        const billingSameAsShipping = document.getElementById("billingSameAsShipping") && document.getElementById("billingSameAsShipping").checked
        if (!billingSameAsShipping) {
            data.append("billingSameAsShipping", "")
        }

        const value = Object.fromEntries(data.entries());
        if (value?.address2) {
            value.location = value.address2
        }
        if (value?.billingSameAsShipping === 'on') {
            value.billingSameAsShipping = 'true';
        }
        if (value?.phoneNumber) {
            value['phoneNumber'] = value.phoneNumber.replaceAll('-', '');

        }

        if (!hasErrorRef.current && !registerFormErrorRef.current) {
            var actionUrl = "api/rest/cb/checkout/b2c-apply-shipping-address";
            var Url = `${window.location.protocol}//${window.location.hostname}/${actionUrl}`
            var resp = '';

            await fetch(Url, {
                method: 'POST',
                headers: new Headers({
                    "content-Type": "application/json",
                    "ShippingGuest": "yes"
                }),
                body: JSON.stringify({ data: value })
            }).then(res => res.json())
                .then(res => {
                    resp = res;
                    setb2cApplyResponse(res);

                })
            //   resp = await Helper.fetchCallFunction(Url, "POST", false, APPLICATION_JSON, JSON.stringify({ data: value }))

            if (b2cApplyResponseRef.current) {

                var response = b2cApplyResponseRef.current.response ? b2cApplyResponseRef.current.response : '';
                //response = JSON.parse(response);

                if (b2cApplyResponseRef.current.result == "success" && response.status == "success") {
                    await handleRegistrationForm()
                    if (!registerFormErrorRef.current) {
                        if (redirectFlagRef.current) {
                            history.push("/checkout/school");
                        } else if (checkRegisterFormRef.current) {
                            history.push("/checkout/delivery?create=true");
                        } else {
                            history.push("/checkout/delivery");
                        }
                    }
                }
                else {
                    const errorList = (b2cApplyResponseRef.current.response && b2cApplyResponseRef.current.response.errorMessage);

                    var count = 0;
                    errorList && errorList.map((item, index) => {
                        if (item.key == 'postalCode') {
                            count++;
                        }
                        if (item.message && item.message === 'quarantine') {
                            handleRestrictModal()
                        } else {
                            if (count == 2) {
                                handleErrorMessage('zipCode', item.message)
                                item.key = 'zipCode';
                                count = 0;
                            } else {
                                handleErrorMessage(item.key, item.message)
                            }
                        }
                    })
                    setErrorMessage(errorList);
                }
            }
        }
    }


    const handleErrorMessage = (key, value) => {
        if (key != 'zipCode' && document.getElementById("shipping_".concat(key))) {
            document.getElementById("shipping_".concat(key)).classList.add("form-error");
        }
        document.getElementById("message-error-div").classList.remove("d-none")
        document.getElementById("message-error-div").classList.add("d-block")
        document.getElementById(key.concat("_error")).innerHTML = value;
        document.getElementById(key.concat("_error")).classList.remove("d-none")
        document.getElementById(key.concat("_error")).classList.add("d-block")
        // var scrollPos = document.getElementById("message-error-div").offsetTop;
        // window.scrollTo({
        //     top: parseInt(scrollPos),
        //     behavior: 'smooth'
        // })
        window.scrollTo(0, 0);
    }

    const handleRemoveErrorMessage = (errorList) => {
        document.getElementById("message-error-div").classList.remove("d-block");
        document.getElementById("message-error-div").classList.add("d-none");
        errorList && errorList.map((item, index) => {
            if (item.key != 'zipCode' && item.key != "addressBook" && document.getElementById("shipping_".concat(item.key))) {
                document.getElementById("shipping_".concat(item.key)).classList.remove("form-error");
            }
            if (document.getElementById(item.key.concat("_error"))) {
                document.getElementById(item.key.concat("_error")).innerHTML = "";
            }
            if (document.getElementById(item.key.concat("_error"))) {
                document.getElementById(item.key.concat("_error")).classList.remove("d-block");
            }
            if (document.getElementById(item.key.concat("_error"))) {
                document.getElementById(item.key.concat("_error")).classList.add("d-none");
            }
        });
    }

    function handleRegistrationMessage(errorList) {
        document.getElementById("message-error-div").classList.remove("d-none");
        document.getElementById("message-error-div").classList.add("d-block");
        errorList && errorList.map((item, index) => {
            if (item.key !== 'userType') {
                document.getElementById(item.key.concat("Reg")).classList.add("form-error")
            }
            document.getElementById(item.key.concat("Reg_error")).innerHTML = item.message;
            document.getElementById(item.key.concat("Reg_error")).classList.remove("d-none");
            document.getElementById(item.key.concat("Reg_error")).classList.add("d-block");
            document.getElementById("message-error-div").scrollIntoView({ behaviour: 'smooth' });
        });
    }

    function handleRemoveRegistrationMessage(errorList) {
        document.getElementById("message-error-div").classList.remove("d-block");
        document.getElementById("message-error-div").classList.add("d-none");
        errorList && errorList.map((item, index) => {
            if (item.key !== 'userType') {
                document.getElementById(item.key.concat("Reg")).classList.remove("form-error");
            }
            document.getElementById(item.key.concat("Reg_error")).innerHTML = '';
            document.getElementById(item.key.concat("Reg_error")).classList.remove("d-block");
            document.getElementById(item.key.concat("Reg_error")).classList.add("d-none");
        });
    }



    const handleShippingAddress = (event) => {
        event.preventDefault();

        if (orderSummaryDetailsRef.current) {
            handleLocalStorageData(event)
            if ((profileDetailsRef.current && profileDetailsRef.current.userType && profileDetailsRef.current.userType == '1') || (profileDetailsRef.current && profileDetailsRef.current.transient && profileDetailsRef.current.transient == true)) {
                handleB2cShippingAddress(event)
            } else if (profileDetailsRef.current && profileDetailsRef.current.userType && profileDetailsRef.current.userType == '2') {
                handleB2iShippingAddress(event)
            } else {
                console.log("else part is working, profile details not available");
            }
        }
    }


    const toggleCheckbox = () => {
        setIsChecked(!isChecked);
    };
    const [showTooltip, setShowTooltip] = useState(false);
    const [showTooltip1, setShowTooltip1] = useState(false);

    const handleMouseEnter = () => {
        setShowTooltip(true);
    };

    const handleMouseLeave = () => {
        setShowTooltip(false);
    };
    const handleMouseEnter1 = () => {
        setShowTooltip1(true);
    };

    const handleMouseLeave1 = () => {
        setShowTooltip1(false);
    };

    const handleAddressBook = () => {
        const phone = document.getElementById("shipping_phoneNumber").value
        const phoneKey = document.getElementById("shipping_phoneNumber").name
        const location = document.getElementById("shipping_location").value
        const locationKey = document.getElementById("shipping_location").name
        console.log("phone=location", phone + "---" + location)
        localStorage.setItem(phoneKey, phone);
        localStorage.setItem(locationKey, location);
        setLocalStorage({ ...localStorageRef.current, [phoneKey]: phone });
        setLocalStorage({ ...localStorageRef.current, [locationKey]: location });
        history.push("/checkout/addressBook")
    };


    const handleChange = (event) => {

        const regex = /^[0-9]+$/;
        const input = event.currentTarget.value;
        if (input.length == 1 && input == "1") {

            event.target.value = "";
        } else {
            if (!regex.test(input)) {

                event.target.value = input.replace(/\D/g, '');
            }
            if (event.currentTarget.id === "phoneNumber" || event.currentTarget.id === "shipping_phoneNumber") {

                const formatted = event.target.value.replace(/(\d{3})(\d{3})?(\d{0,4})?/, (match, p1, p2, p3) => {

                    let result = p1;
                    if (p2) result += `-${p2}`;
                    if (p3) result += `-${p3}`;
                    return result;
                });
                event.target.value = formatted
            }
        }
    }
    async function handleEstimateShipping(zipCode) {
        var actionUrl = "api/rest/cb/checkout/estimate-shipping";
        var Url = `${window.location.protocol}//${window.location.hostname}/${actionUrl}`
        var res = await Helper.fetchCallFunction(Url, "POST", false, APPLICATION_JSON, JSON.stringify({ zipCode: zipCode }))
        if (res.result == "success") {

            getOrderSummaryDetails();
        } else {
            console.log("res.result", res.result);
        }
    }

    async function handleZipCodeValidation(data) {

        const zipCode = data && data.zip_code ? data.zip_code : '';
        if (zipCode && zipCode.length >= 5) {
            var actionUrl = "api/rest/cb/checkout/validate-zip-code";
            var Url = `${window.location.protocol}//${window.location.hostname}/${actionUrl}`
            var res = await Helper.fetchCallFunction(Url, "POST", false, APPLICATION_JSON, JSON.stringify({ zipCode: zipCode }))
            if (res.result == "success") {
                console.log("success----", res)
                // getOrderSummaryDetails();
                handleEstimateShipping(zipCode)

            } else {
                console.log("Zip Code Validation Fails");
            }
        } else {
            console.log("zip code should be minimum of 5 digits");
        }
    }
    const handleChangeCity = (city) => {
        setCity(city);
        localStorage.setItem('city', city);
        setLocalStorage({ ...localStorageRef.current, ['city']: city });
    }


    const handleZipCodeApiResponse = (data) => {

        if (document.getElementById('zipcodeApiResponseCode')) {
            setResponseCode(0);
        }

        if (data.error_msg) {
            setResponseCode(data.error_code);
            // We are not showing any error to the user, simply letting the user to enter the data
        } else if ("city" in data) {
            console.log('data,,,', data);
            setCity(data.city);
            setState(data.state);
            localStorage.setItem(city, data.city);
            localStorage.setItem(state, data.state);
            setLocalStorage({ ...localStorageRef.current, [city]: data.city });
            setLocalStorage({ ...localStorageRef.current, [state]: data.state });
            // if (stateRef.current && stateRef.current) {
            //     document.getElementById(stateRef.current).setAttribute("selected", "selected")
            // }
            handleZipCodeValidation(data);
        } else {
            console.log("data in else ", data);
        }
    }

    // get call to find out city and state
    const getCityAndStateByZipCode = (code) => {
        setDisabled(true);
        setCity('');
        setState('');
        localStorage.setItem(city, '');
        setLocalStorage({ ...localStorageRef.current, [city]: '' });
        setTimeout(() => {


            console.log('getCityAndStateByZipCode called...', code);
            setZipCode(code);

            if (zipCodeRef.current == '') {
                setCity('');
                setState('');
                localStorage.setItem(city, '');
                setLocalStorage({ ...localStorageRef.current, [city]: '' });
            }

            if (Helper.isValidZipcodeUS(zipCodeRef.current.trim())) {
                console.log('valid zipcode', code);
                if (cache.current[zipCodeRef.current]) {
                    handleZipCodeApiResponse(cache.current[zipCodeRef.current]);
                    setDisabled(false);
                } else {
                    const url = `https://www.zipcodeapi.com/rest/${ZIP_CODE_API_KEY}/info.json/${zipCodeRef.current.trim()}/radians`;
                    fetch(url, {
                        method: 'GET',
                        headers: {
                            'Accept': APPLICATION_JSON,
                        }
                    })
                        .then(response => {
                            var responseJson = response.json();
                            return responseJson;
                        })
                        .then(data => {

                            handleZipCodeApiResponse(data);
                            // Store in cache
                            cache.current[zipCodeRef.current] = data;
                            setDisabled(false);
                        })
                        .catch(err => {

                            if (document.getElementById('zipcodeApiResponseCode')) {

                                setResponseCode(err.status);
                            }
                            setDisabled(false);
                        })
                }
            } else {
                console.log('invalid zip and cleared city and state', code);
                setCity('');
                setState('');
                localStorage.setItem(city, '');
                setLocalStorage({ ...localStorageRef.current, [city]: '' });
                setDisabled(false);
            }
        }, 500);
    }



    // get the orderSummary details
    const getOrderSummaryDetails = async () => {
        setOrderSummaryLoading(true);
        const body = {
            "isReviewPage": false,
            "isShippingPage": true,
            "requiredReprice": true
        }
        var orderSummary = await Helper.getOrderSummary(body);
        setOrderSummaryDetails(orderSummary);
        setOrderSummaryLoading(false);
        setIsLoading(false);
    }

    return (
        <div data-cont-id={containerObject.contentId} data-zone={dataZone} data-page-id={contentId} data-template-name={templateName} className={`vast-plugin-content row justify-content-center c-account-page c-school-page c-shipping-page gx-0`}>
            {profileDetailsRef.current && profileDetailsRef.current.transient == true ? <>{containerObject?.attributes?.webMessage? <div dangerouslySetInnerHTML={{ __html: containerObject?.attributes?.webMessage }}></div>:""}</>:""}
            <div className="col-12 col-md-11 my-md-5 my-2 trpadding">
                {isLoading && <Loader />}
                <div className="row cb-shipping-custom">
                    <div className="col-12 col-md-8" id="visibleElement">
                        {restrictModalGeoRef.current ?
                            <ProductRestrictionModal
                                restrictModalDetail={restrictModalGeoRef.current}
                                shipGroupDetails={shipGroupDetails}
                                shippingGroupDetailRef={shippingGroupDetailRef.current}
                                setShippingGroupDetail={setShippingGroupDetail}
                                handleRestrictModal={handleRestrictModal}
                                emailUpdateRef={emailUpdateRef.current}
                                setEmailUpdate={setEmailUpdate} />
                            : ''}
                        {/* <div id="err" className="message message-red form-error-messages col-md-12 mx-auto"> */}
                        <div id="message-error-div" className="d-none alert alert-danger">
                            <div className="col-12">
                                {/* <div id='resultExisitingError' style={{ color: "black" }} dangerouslySetInnerHTML={{ __html: setErrorMessageRef.current }}></div> */}
                                <div id='firstName_error' className="d-none text-dark"></div>
                                <div id='lastName_error' className="d-none text-dark"></div>
                                <div id='firstNameReg_error' className="d-none text-dark"></div>
                                <div id='lastNameReg_error' className="d-none text-dark"></div>
                                <div id='emailReg_error' className="d-none text-dark"></div>
                                <div id='passwordReg_error' className="d-none text-dark" ></div>
                                <div id='emailAddress_error' className="d-none text-dark"></div>
                                <div id='phoneNumber_error' className="d-none text-dark"></div>
                                <div id='companyName_error' className="d-none text-dark"></div>
                                <div id="address1_error" className="d-none text-dark"></div>
                                <div id='postalCode_error' className="d-none text-dark"></div>
                                <div id='zipCode_error' className="d-none text-dark"></div>
                                <div id='city_error' className="d-none text-dark"></div>
                                <div id='state_error' className="d-none text-dark"></div>
                                <div id='userTypeReg_error' className="d-none text-dark"></div>
                                <div id="addressBook_error" className="d-none text-dark"></div>
                                <div id="message-error" className="col-12 err-message-text"></div>
                            </div>
                        </div>
                        {/* </div> */}
                        <div className="row">
                            <div className="col-6 col-md-6 text-left mb-3">
                                <h1 className="c-account-heading">Shipping Address</h1>
                            </div>

                            <div id="international-link" className="col-6 col-md-6 text-end mb-3 d-none">
                                <Link to={profileDetailsRef.current && profileDetailsRef.current.transient ? "/checkout/register?intl=true" : "/checkout/int/save"} className="c-international-link">
                                    <i className="bi bi-globe2"></i>
                                    <span> Need to Ship Internationally?</span>
                                </Link>
                            </div>
                            {shippingGroupDetailRef.current && shippingGroupDetailRef.current.accountSuccessMsg || shippingGroupDetailRef.current && shippingGroupDetailRef.current.b2ISuccessMsg || shippingGroupDetailRef.current && shippingGroupDetailRef.current.quarantineRemoveMsg ?
                                <div className='cb-ship-error-msg'>
                                    <div className="d-block alert alert-danger alert-yellow ml-5 mb-3 mr-auto ml-auto">
                                        <p className="black-color"
                                            dangerouslySetInnerHTML={{
                                                __html: shippingGroupDetailRef.current && shippingGroupDetailRef.current.accountSuccessMsg ? shippingGroupDetailRef.current.accountSuccessMsg :
                                                    shippingGroupDetailRef.current && shippingGroupDetailRef.current.b2ISuccessMsg ? shippingGroupDetailRef.current.b2ISuccessMsg :
                                                        shippingGroupDetailRef.current && shippingGroupDetailRef.current.quarantineRemoveMsg ? shippingGroupDetailRef.current.quarantineRemoveMsg : ''
                                            }}>
                                        </p>
                                    </div>
                                </div>
                                : ""}
                        </div>
                        {/* shipping profile details */}
                        <form id="shippingAddress" onSubmit={handleShippingAddress} className="c-account-page" data-hs-cf-bound="true" noValidate>
                            <div style={{ display: 'none' }}></div><div style={{ display: 'none' }}></div>
                            <div className="row g-3 g-md-5 mb-3">
                                <div className="col-md-6">
                                    <label for="firstName" className="form-label">First Name</label>
                                    <input maxlength="19" name="firstName" defaultValue={localStorageRef.current && localStorageRef.current["firstName"] ?
                                        localStorageRef.current["firstName"]
                                        : shippingGroupDetailRef.current?.firstName ?
                                            shippingGroupDetailRef.current.firstName : ""} id="shipping_firstName" type="text" className="form-control" />

                                </div>
                                <div className="col-md-6">
                                    <label for="lastName" className="form-label">Last Name</label>
                                    <input maxlength="19" name="lastName" defaultValue={localStorageRef.current && localStorageRef.current["lastName"] ?
                                        localStorageRef.current["lastName"]
                                        : shippingGroupDetailRef.current?.lastName ?
                                            shippingGroupDetailRef.current.lastName : ""} id="shipping_lastName" type="text" className="form-control" />
                                </div>
                            </div>

                            <div className="row g-3 g-md-5 mb-3">
                                <div className="col-md-6">
                                    <label for="email" className="form-label">Email</label>
                                    <input maxlength="255" name="emailAddress" defaultValue={localStorageRef.current && localStorageRef.current["emailAddress"] ?
                                        localStorageRef.current["emailAddress"] : emailUpdateRef.current ? emailUpdateRef.current
                                            : ""} id="shipping_emailAddress" type="email" className="form-control" autoComplete='new-password' />
                                </div>
                                <div className="col-md-6">
                                    <label for="phone" className="form-label">Phone</label>
                                    <input maxlength="12" name="phoneNumber" defaultValue={localStorageRef.current && localStorageRef.current["phoneNumber"] ?
                                        localStorageRef.current["phoneNumber"] : shippingGroupDetailRef.current?.phoneNumber ?
                                            Helper.phoneNumberFormatter(shippingGroupDetailRef.current.phoneNumber) : ""} id="shipping_phoneNumber" type="text" className="form-control" onChange={handleChange} />
                                </div>
                            </div>
                            {profileDetailsRef.current && profileDetailsRef.current.userType && profileDetailsRef.current.userType == '2' ?
                                <div id="b2i-shipping" className="d-block">
                                    <div className="row g-3 g-md-5 mb-4">
                                        <div className="col-12 col-md-12">
                                            <label for="address2" className="form-label">Attention</label>
                                            <input maxlength="40" name="location" defaultValue={localStorageRef.current && localStorageRef.current["location"] ?
                                                localStorageRef.current["location"] : shippingGroupDetailRef.current?.location ? shippingGroupDetailRef.current.location :
                                                    ""} id="shipping_location" placeholder="Ex: John Smith Bio Lab or PO 15596" type="text" className="form-control" />
                                        </div>
                                    </div>
                                    <div className="row g-3 g-md-0 b2i-address-section">
                                        <div className="col-12 col-md-12">
                                            <div className="alert alert-warning alert-yellow">
                                                <div className="row align-items-start">
                                                    <div className="col-md-6">
                                                        {shippingGroupDetailRef.current && shippingGroupDetailRef.current.companyName ?
                                                            <address>
                                                                {shippingGroupDetailRef.current.companyName}<br />
                                                                {shippingGroupDetailRef.current.address1}{shippingGroupDetailRef.current && shippingGroupDetailRef.current.address2 ? (" " + shippingGroupDetailRef.current.address2) : ""}<br />
                                                                {shippingGroupDetailRef.current.city}, {shippingGroupDetailRef.current.state} {shippingGroupDetailRef.current.postalCode}
                                                            </address>
                                                            : <p>
                                                                <i className="bi bi-info-circle-fill"></i>
                                                                {" Please click on Choose Address to select a shipping address from your organization's address book."}
                                                            </p>
                                                        }

                                                    </div>
                                                    <div className="col-md-6 mx-auto">
                                                        <div className="text-end">
                                                            <button type="button" onClick={handleAddressBook} className="btn btn-outline-secondary c-shipping-change-btn shipping-change-addr-btn fw-bold">
                                                                {shippingGroupDetailRef.current && shippingGroupDetailRef.current.companyName ? "Change Address" : "Choose Address"}</button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div> : ""}
                            {profileDetailsRef.current && profileDetailsRef.current.transient || profileDetailsRef.current && profileDetailsRef.current.userType && profileDetailsRef.current.userType == '1' ?
                                <div id="b2c-shipping" className="d-block">
                                    <div className="row g-3 g-md-5 mb-3">
                                        <div className="col-md-12">
                                            <label for="company" className="form-label">School or Company (optional)</label>
                                            <input maxlength="40" name="companyName" id="shipping_companyName" defaultValue={localStorageRef.current && localStorageRef.current["companyName"] ?
                                                localStorageRef.current["companyName"] :
                                                shippingGroupDetailRef.current && shippingGroupDetailRef.current.companyName ?
                                                    shippingGroupDetailRef.current.companyName : ""} type="text" className="form-control" />
                                        </div>
                                    </div>

                                    <div className="row g-3 g-md-5 mb-3">
                                        <div className="col-md-6">
                                            <label for="address" className="form-label">Street Address</label>
                                            <input maxlength="40" name="address1" id="shipping_address1" type="text" defaultValue={localStorageRef.current && localStorageRef.current["address1"] ?
                                                localStorageRef.current["address1"] :
                                                shippingGroupDetailRef.current && shippingGroupDetailRef.current.address1 ?
                                                    shippingGroupDetailRef.current.address1 : ""} className="form-control" />
                                        </div>

                                        <div className="col-md-6">
                                            <label for="address2" className="form-label">Attention</label>
                                            <input maxlength="40" name="address2" id="address2" defaultValue={localStorageRef.current && localStorageRef.current["address2"] ?
                                                localStorageRef.current["address2"] :
                                                shippingGroupDetailRef.current && shippingGroupDetailRef.current.address2 ?
                                                    shippingGroupDetailRef.current.address2 : shippingGroupDetailRef.current?.location ? shippingGroupDetailRef.current.location : ""} placeholder="Ex: John Smith Bio Lab or PO 15596" type="text" className="form-control" />
                                        </div>
                                    </div>

                                    <div className="row g-3 g-md-5 mb-3">
                                        <div className="col-md-6">
                                            <label for="zip" className="form-label">Zip</label>
                                            <input maxlength="10" name="postalCode" id="shipping_postalCode" defaultValue={localStorageRef.current && localStorageRef.current["postalCode"] ?
                                                localStorageRef.current["postalCode"] :
                                                zipCodeRef.current && zipCodeRef.current ?
                                                    zipCodeRef.current : ""} type="text" className="form-control" onChange={(e) => getCityAndStateByZipCode(e.currentTarget.value)} />
                                        </div>
                                        <div className="col"></div>
                                    </div>

                                    <div className="row g-3 g-md-5 mb-4 mb-lg-0">
                                        <div className="col-12 col-md-6">
                                            <label for="city" className="form-label">City</label>
                                            <input maxlength="30" name="city" id="shipping_city" type="text" onChange={(e) => { handleChangeCity(e.currentTarget.value) }} value={cityRef.current ? cityRef.current : ''} className="form-control" />
                                        </div>
                                        <div className="col-12 col-md-6">
                                            <label for="state" className="form-label">State</label>
                                            <select name="state" id="shipping_state" className="form-select">
                                                <option id="default-select" selected={stateRef.current === '' ? true : false}></option>
                                                <option id="AL" selected={stateRef.current == 'AL' ? true : false} value="AL">AL - Alabama</option>
                                                <option id="AK" selected={stateRef.current == 'AK' ? true : false} value="AK">AK - Alaska</option>
                                                <option id="AZ" selected={stateRef.current == 'AZ' ? true : false} value="AZ">AZ - Arizona</option>
                                                <option id="AR" selected={stateRef.current == 'AR' ? true : false} value="AR">AR - Arkansas</option>
                                                <option id="CA" selected={stateRef.current == 'CA' ? true : false} value="CA">CA - California</option>
                                                <option id="CO" selected={stateRef.current == 'CO' ? true : false} value="CO">CO - Colorado</option>
                                                <option id="CT" selected={stateRef.current == 'CT' ? true : false} value="CT">CT - Connecticut</option>
                                                <option id="DE" selected={stateRef.current == 'DE' ? true : false} value="DE">DE - Delaware</option>
                                                <option id="DC" selected={stateRef.current == 'DC' ? true : false} value="DC">DC - District of Columbia</option>
                                                <option id="FL" selected={stateRef.current == 'FL' ? true : false} value="FL">FL - Florida</option>
                                                <option id="GA" selected={stateRef.current == 'GA' ? true : false} value="GA">GA - Georgia</option>
                                                <option id="HI" selected={stateRef.current == 'HI' ? true : false} value="HI">HI - Hawaii</option>
                                                <option id="ID" selected={stateRef.current == 'ID' ? true : false} value="ID">ID - Idaho</option>
                                                <option id="IL" selected={stateRef.current == 'IL' ? true : false} value="IL">IL - Illinois</option>
                                                <option id="IN" selected={stateRef.current == 'IN' ? true : false} value="IN">IN - Indiana</option>
                                                <option id="IA" selected={stateRef.current == 'IA' ? true : false} value="IA">IA - Iowa</option>
                                                <option id="KS" selected={stateRef.current == 'KS' ? true : false} value="KS">KS - Kansas</option>
                                                <option id="KY" selected={stateRef.current == 'KY' ? true : false} value="KY">KY - Kentucky</option>
                                                <option id="LA" selected={stateRef.current == 'LA' ? true : false} value="LA">LA - Louisiana</option>
                                                <option id="ME" selected={stateRef.current == 'ME' ? true : false} value="ME">ME - Maine</option>
                                                <option id="MD" selected={stateRef.current == 'MD' ? true : false} value="MD">MD - Maryland</option>
                                                <option id="MA" selected={stateRef.current == 'MA' ? true : false} value="MA">MA - Massachusetts</option>
                                                <option id="MI" selected={stateRef.current == 'MI' ? true : false} value="MI">MI - Michigan</option>
                                                <option id="MN" selected={stateRef.current == 'MN' ? true : false} value="MN">MN - Minnesota</option>
                                                <option id="MS" selected={stateRef.current == 'MS' ? true : false} value="MS">MS - Mississippi</option>
                                                <option id="MO" selected={stateRef.current == 'MO' ? true : false} value="MO">MO - Missouri</option>
                                                <option id="MT" selected={stateRef.current == 'MT' ? true : false} value="MT">MT - Montana</option>
                                                <option id="NE" selected={stateRef.current == 'NE' ? true : false} value="NE">NE - Nebraska</option>
                                                <option id="NV" selected={stateRef.current == 'NV' ? true : false} value="NV">NV - Nevada </option>
                                                <option id="NH" selected={stateRef.current == 'NH' ? true : false} value="NH">NH - New Hampshire</option>
                                                <option id="NJ" selected={stateRef.current == 'NJ' ? true : false} value="NJ">NJ - New Jersey</option>
                                                <option id="NM" selected={stateRef.current == 'NM' ? true : false} value="NM">NM - New Mexico</option>
                                                <option id="NY" selected={stateRef.current == 'NY' ? true : false} value="NY">NY - New York</option>
                                                <option id="NC" selected={stateRef.current == 'NC' ? true : false} value="NC">NC - North Carolina</option>
                                                <option id="ND" selected={stateRef.current == 'ND' ? true : false} value="ND">ND - North Dakota</option>
                                                <option id="OH" selected={stateRef.current == 'OH' ? true : false} value="OH">OH - Ohio</option>
                                                <option id="OK" selected={stateRef.current == 'OK' ? true : false} value="OK">OK - Oklahoma</option>
                                                <option id="OR" selected={stateRef.current == 'OR' ? true : false} value="OR">OR - Oregon</option>
                                                <option id="PA" selected={stateRef.current == 'PA' ? true : false} value="PA">PA - Pennsylvania</option>
                                                <option id="RI" selected={stateRef.current == 'RI' ? true : false} value="RI">RI - Rhode Island</option>
                                                <option id="SC" selected={stateRef.current == 'SC' ? true : false} value="SC">SC - South Carolina</option>
                                                <option id="SD" selected={stateRef.current == 'SD' ? true : false} value="SD">SD - South Dakota</option>
                                                <option id="TN" selected={stateRef.current == 'TN' ? true : false} value="TN">TN - Tennessee</option>
                                                <option id="TX" selected={stateRef.current == 'TX' ? true : false} value="TX">TX - Texas</option>
                                                <option id="UT" selected={stateRef.current == 'UT' ? true : false} value="UT">UT - Utah</option>
                                                <option id="VT" selected={stateRef.current == 'VT' ? true : false} value="VT">VT - Vermont</option>
                                                <option id="VA" selected={stateRef.current == 'VA' ? true : false} value="VA">VA - Virginia</option>
                                                <option id="WA" selected={stateRef.current == 'WA' ? true : false} value="WA">WA - Washington</option>
                                                <option id="WV" selected={stateRef.current == 'WV' ? true : false} value="WV">WV - West Virginia</option>
                                                <option id="WI" selected={stateRef.current == 'WI' ? true : false} value="WI">WI - Wisconsin</option>
                                                <option id="WY" selected={stateRef.current == 'WY' ? true : false} value="WY">WY - Wyoming</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div className="row mb-3 mb-md-0">
                                        <div className="col-12 col-md-6 mb-lg-4">
                                            <div className="form-check c-register-check">
                                                {/* <input name="defaultshipping" checked="checked" style={{ display: 'none' }} id="defaultshipping" type="checkbox" /> */}
                                                <input name="billingSameAsShipping" id="billingSameAsShipping" type="checkbox" className="form-check-input position-static" />
                                                <label className="form-check-label form-check-label-padding" for="billingSameAsShipping">&nbsp;Use this address for billing</label>
                                            </div>
                                        </div>
                                    </div>
                                </div> : ""}

                            {profileDetailsRef.current && profileDetailsRef.current.transient == true ? <>
                                <div className="text-left mt-3 mb-3">
                                    <h1 className="c-account-heading">Create An Account (optional)</h1>
                                </div>
                                <form method="post" action="choose-account-type" id="registerForm" className="c-account-page" onSubmit="">
                                    <div className="row g-3 mb-3">
                                        <div className="col-md-6">
                                            <label className="form-label" for="firstName">First Name</label>
                                            <input maxlength="19" name="firstName" id="firstNameReg" type="text" className="form-control" />
                                        </div>
                                    </div>
                                    <div className="row g-3 mb-3">
                                        <div className="col-md-6">
                                            <label className="form-label" for="lastName">Last Name</label>
                                            <input maxlength="19" name="lastName" id="lastNameReg" type="text" className="form-control" />
                                        </div>
                                    </div>
                                    <div className="row g-3 mb-3">
                                        <div className="col-12 col-md-6">
                                            <label className="form-label" for="email">Email</label>
                                            <input maxlength="256" name="email" id="emailReg" type="text" className="form-control c-read-only" autoComplete='false' />
                                        </div>
                                        <div className="col-12 col-md-6">
                                            <div className="form-check c-register-check">
                                                <input type="checkbox" className="form-check-input" onChange={toggleCheckbox} />
                                                <label className="form-check-label" for="blankCheckbox">
                                                    <strong>Yes</strong>, subscribe me to your newsletter.<br />You may opt out any time.<Link to="/help/terms-of-use" style={{ textDecoration: 'none' }} target="_blank">Terms</Link> and <Link to="/help/privacy-and-security" style={{ textDecoration: 'none' }} target="_blank">Privacy Policy</Link>
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row g-3 mb-4">
                                        <div className="col-md-6">
                                            <label for="password" className="form-label">Password</label>
                                            <div className="c-input-tooltip c-input-password" style={{ position: 'relative' }} >
                                                <input name="password" id="passwordReg" type={isRevealPwd ? "text" : "password"} className="form-control" value={pwd} onChange={e => setPwd(e.target.value)} autoComplete='new-password' />
                                                <Link className="c-register-passShow" style={{ textDecoration: 'none', position: 'absolute' }} id="show-password-field" onClick={() => setIsRevealPwd(prevState => !prevState)}>
                                                    {isRevealPwd ? 'HIDE' : 'SHOW'}
                                                </Link>
                                                <span className="c-tooltip" onMouseEnter={handleMouseEnter}
                                                    onMouseLeave={handleMouseLeave}
                                                    style={{ position: 'relative' }}>
                                                    <i className="bi bi-question-circle-fill"></i>
                                                    {showTooltip && (
                                                        <div style={{
                                                            position: 'absolute', top: '-70px', left: '-80px', background: '#fbf3bf', zIndex: '1', width: '200px',
                                                            padding: '0.875rem', border: "0.063rem solid #ccc", boxShadow: '0 0 0.625rem #ccc', lineHeight: '1.125rem', letterSpacing: '0',
                                                            color: '#333', borderRadius: '0.313rem', width: '200px', fontSize: '0.75rem', fontWeight: '400', textAlign: 'left'
                                                        }}>
                                                            <div style={{
                                                                position: 'absolute', top: '65px', left: '50%', marginLeft: '-13px', width: '0', height: '0',
                                                                borderLeft: '5px solid transparent', borderRight: '5px solid transparent', borderTop: '7px solid #333',
                                                            }}></div>
                                                            Passwords must be at least 6 characters long.
                                                        </div>
                                                    )}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-12  mb-3">
                                            <div className="text-left">
                                                <p className="text-left c-regular-text">
                                                    Are you ordering on behalf of school or business?
                                                    <span className="c-tooltip" onMouseEnter={handleMouseEnter1}
                                                        onMouseLeave={handleMouseLeave1}
                                                        style={{ position: 'relative' }}>
                                                        <i className="bi bi-question-circle-fill"></i>
                                                        {showTooltip1 && (
                                                            <div style={{
                                                                position: 'absolute', top: '-186px', left: '-88px', zIndex: '1', width: '200px', padding: '0.875rem',
                                                                backgroundColor: '#fbf3bf', border: '0.063rem solid #ccc', boxShadow: '0 0 0.625rem #ccc', lineHeight: '1.125rem',
                                                                letterSpacing: '0', color: '#000000', borderRadius: '0.313rem', textAlign: 'left',
                                                                fontSize: '0.75rem', fontWeight: '400'
                                                            }}>
                                                                <div style={{
                                                                    position: 'absolute', top: '175px', left: '53%', marginLeft: '-15px', width: '0', height: '0',
                                                                    borderLeft: '5px solid transparent', borderRight: '5px solid transparent', borderTop: '7px solid #333',
                                                                }}></div>
                                                                If purchasing for a school or institution, select <strong>yes</strong> to link your online account to your school or institution's corporate account. Please Note: this corporate account must have an existing Net 30 account with carolina.
                                                            </div>
                                                        )}
                                                    </span>
                                                </p>
                                            </div>
                                            <div className="form-check form-check-inline">
                                                <input name="custType" id="exampleRadios1" type="radio" value="institution" className="form-check-input" />
                                                <label className="form-check-label" for="exampleRadios1">
                                                    Yes
                                                </label>
                                            </div>
                                            <div className="form-check form-check-inline">
                                                <input name="custType" id="exampleRadios2" type="radio" value="personal" className="form-check-input" />
                                                <label className="form-check-label" for="exampleRadios2">
                                                    No
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row g-3 mb-3">
                                        <div className="col-md-6 d-grid">
                                            <input name="registrationStep" id="registrationStep" type="hidden" value="1" />
                                            <input name="chooseAccountTypeErrorURL" type="hidden" value="/account/register" />
                                        </div>
                                    </div>
                                    {/* Continue button */}
                                </form>
                            </>
                                : ""}
                            <input id="zipcodeApiResponseCode" name='zipcodeApiResponseCode' type="hidden" value={responseCode} />
                            <div className={`row g-3 ${profileDetailsRef.current?.transient ? 'mb-3' : profileDetailsRef.current?.userType == 1 ? 'g-md-5 mb-4 mt-md-1' : profileDetailsRef.current?.userType == 2 ? 'g-md-5 mb-md-0 mb-4' : ''}`}>
                                <div className={`${profileDetailsRef.current?.transient || profileDetailsRef.current?.userType == 1 ? 'col-md-6 d-grid' : profileDetailsRef.current?.userType == 2 ? 'col-md-5 d-grid' : ''}`}>
                                    <button type="submit" disabled={disabledRef.current == true ? true : ""} className="btn btn-primary block">
                                        Continue
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>

                    <OrderSummary orderSummaryDetails={orderSummaryDetailsRef.current} isOrderSummaryLoading={isOrderSummaryLoadingRef.current} handleCallBackOrderSummary={handleCallBackOrderSummary} />

                </div>

                <div id="checkoutSpacer"></div>


            </div>
            <div className="modal fade c-modal" id="default-modal" tabindex="-1" aria-labelledby="defaultModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered modal-fullscreen-sm-down modal-lg-a">
                    <div className="modal-content">
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close">
                        </button>
                        <div className="modal-body">
                        </div>
                    </div>
                </div>
            </div>
        </div >
    )
}

export default CheckoutShipping
